import { render } from "./manageexamview.vue?vue&type=template&id=547e755f&scoped=true"
import script from "./manageexamview.vue?vue&type=script&lang=js"
export * from "./manageexamview.vue?vue&type=script&lang=js"

import "./manageexamview.vue?vue&type=style&index=0&id=547e755f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547e755f"]])

export default __exports__